<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <TestimonialsForm :baseTestimonial="testimonial" :baseTestimonialName="name" :loading="loading" @submit-requested="submitRequested"></TestimonialsForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TestimonialsForm from '../forms/FormTestimonials.vue'
import router from '@/router';

export default {
    data() {
        return {
            testimonial: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { TestimonialsForm },
    computed: {
        ...mapState('testimonials', ['getTestimonialByIdOutput']),
    },
    methods: {
        ...mapActions('testimonials', ['getTestimonialById']),
        ...mapActions('testimonials', ['putTestimonial']),
        submitRequested(testimonial) {
            this.putTestimonial(testimonial);
        },
    },
    mounted() {
        if (!this.$route.query.id) {
            router.push({ name: 'TestimonialsList' });
        }

        this.getTestimonialById(this.$route.query.id);
    },
    watch: {
        getTestimonialByIdOutput(testimonialOutput) {
            if (!testimonialOutput || !testimonialOutput.data) {
                router.push({ name: 'TestimonialsList' });
            } else {
                this.testimonial = testimonialOutput.data;
                this.loading = false;
            }
        }
    }
}
</script>